module.exports = "<div class=\"c-branding c-branding--journey\"> <div class=c-branding__headings> <h2 class=c-branding__heading>Welcome to the Hotel Lobby</h2> <p class=c-branding__subheading>Where everything comes together</p> <div class=c-branding__logo> <img src=https://s3-eu-west-1.amazonaws.com/lobby-live-uploads/public/branding-media/journey-logo.svg alt=\"Journey - Hotel Digital Marketing\"/> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/base/views/brandingBanner.html
// module id = 547
// module chunks = 0